// Booking panel presentation (bible 4.14), kept apart from the booking behaviour below. Nothing here changes what
// the form submits or how slots load.
// Submit button: Freeform renders (and, while it works, swaps) the label as bare text. The kit's button wants
// <span class="ed-btn__labels"> (idle + "Booking…" crossfade) and a real .ed-btn__dot, so the markup is wrapped on
// DOM ready and handed back to Freeform as its original and processing text. aria-busy mirrors Freeform's own
// .freeform-processing class, which is what turns on the breathing dot.
(function () {
    const BUSY_LABEL = 'Booking…';
    const escapeHtml = (text) => text.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    const start = () => {
        const form = document.querySelector('[data-booking] form');
        const button = form && form.querySelector('button[data-freeform-action="submit"]');

        if (!button || button.querySelector('.ed-btn__labels')) {
            return;
        }

        const label = button.textContent.trim();
        const markup = `<span class="ed-btn__labels"><span class="ed-btn__label">${escapeHtml(label)}</span><span class="ed-btn__label ed-btn__label--busy" aria-hidden="true">${BUSY_LABEL}</span></span><span class="ed-btn__dot" aria-hidden="true"></span>`;

        const hand = () => {
            button.dataset.originalText = markup;
            button.dataset.processingText = markup;
        };

        button.innerHTML = markup;
        hand();

        // Freeform captures its original text when it starts, and locks the button on submit (after this click)
        button.addEventListener('click', hand, true);
        form.addEventListener('freeform-ready', () => setTimeout(hand, 0));

        // Set one frame after the new markup is in, so the label crossfades instead of appearing finished
        const sync = () => {
            const busy = button.classList.contains('freeform-processing');

            if (!busy) {
                button.removeAttribute('aria-busy');
                return;
            }

            requestAnimationFrame(() => requestAnimationFrame(() => {
                if (button.classList.contains('freeform-processing')) {
                    button.setAttribute('aria-busy', 'true');
                }
            }));
        };

        new MutationObserver(sync).observe(button, { attributes: true, attributeFilter: ['class'] });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();

document.addEventListener('change', event => {
    if (event.target.matches('[data-booking-chooser]') && event.target.value) {
        window.location.assign(event.target.value);
    }
});

// Back navigation restores the chosen option
window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-booking-chooser]').forEach(select => {
        select.value = '';
    });
});

window.addEventListener('load', () => {
    const booking = document.querySelector('[data-booking]');
    const form = booking?.querySelector('form');

    if (!form) {
        return;
    }

    const displayHomeInput = booking.querySelector('[data-booking-display-home]');
    const dateInput = booking.querySelector('[data-booking-date]');
    const slotsList = booking.querySelector('[data-booking-slots-list]');
    const slotsMessage = booking.querySelector('[data-booking-slots-message]');
    const slotTemplate = booking.querySelector('[data-booking-slot-template]');
    const hours = booking.querySelector('[data-booking-hours]');
    const hoursList = booking.querySelector('[data-booking-hours-list]');

    const displayHomeIdField = form.querySelector('[name="displayHomeId"]');
    const displayHomeField = form.querySelector('[name="displayHome"]');
    const appointmentStartField = form.querySelector('[name="appointmentStart"]');

    if (!displayHomeIdField || !appointmentStartField) {
        console.warn('[Bookings] The booking form is missing its displayHomeId or appointmentStart hidden field.');
        return;
    }

    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    let request = null;
    let hoursRequest = null;
    let closedDays = [];

    // `state` is presentation only: it drives the slot tray styling (editorial/_booking.scss) through
    // data-booking-state = idle | loading | ready | empty | closed | error | invalid
    function setMessage(message, state) {
        slotsMessage.textContent = message;
        slotsMessage.hidden = !message;

        if (state) {
            booking.dataset.bookingState = state;
        }
    }

    function syncDisplayHome() {
        const option = displayHomeInput.options[displayHomeInput.selectedIndex];

        displayHomeIdField.value = displayHomeInput.value;
        if (displayHomeField) {
            displayHomeField.value = displayHomeInput.value ? option.text : '';
        }
    }

    // Presentation only: the tray's height and padding ease between states. Measure where the tray is now, apply the
    // change with transitions off to measure where it ends up, pin the old values inline, then let go with
    // .is-shifting (editorial/_booking.scss). Every move starts exactly where the tray is, so there is no dip and no
    // overshoot, and an interrupted move simply continues from the height it had reached.
    const tray = booking.querySelector('.ed-btray');
    let shiftToken = 0;

    function shiftTray(change) {
        if (!tray || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            change();
            return;
        }

        const token = ++shiftToken;
        const before = tray.getBoundingClientRect().height;
        const beforePad = getComputedStyle(tray).paddingBlockStart;

        tray.classList.remove('is-shifting');
        tray.style.blockSize = '';
        tray.style.paddingBlock = '';
        change();

        const after = tray.getBoundingClientRect().height;

        if (!before || Math.abs(before - after) < 1) {
            return;
        }

        tray.style.blockSize = `${before}px`;
        tray.style.paddingBlock = beforePad;
        void tray.offsetHeight;
        tray.classList.add('is-shifting');
        tray.style.blockSize = `${after}px`;
        tray.style.paddingBlock = '';

        const done = () => {
            if (token !== shiftToken) {
                return;
            }
            tray.classList.remove('is-shifting');
            tray.style.blockSize = '';
        };

        tray.addEventListener('transitionend', function end(event) {
            if (event.target === tray && event.propertyName === 'block-size') {
                tray.removeEventListener('transitionend', end);
                done();
            }
        });
        setTimeout(done, 600);
    }

    // One call per state: the message, the data-booking-state and the chips change together, and the tray eases
    function showTray(message, state, slots = []) {
        shiftTray(() => {
            setMessage(message, state);
            renderSlots(slots);
        });
    }

    function renderSlots(slots) {
        slotsList.replaceChildren();

        slots.forEach(slot => {
            const option = slotTemplate.content.firstElementChild.cloneNode(true);
            const input = option.querySelector('input');

            input.value = slot.value;
            input.checked = slot.value === appointmentStartField.value;
            option.querySelector('span').textContent = slot.label;

            slotsList.appendChild(option);
        });

        if (!slots.some(slot => slot.value === appointmentStartField.value)) {
            appointmentStartField.value = '';
        }
    }

    function getClosedDay(date) {
        if (!date) {
            return null;
        }

        const [year, month, day] = date.split('-').map(Number);
        const weekday = weekdays[new Date(year, month - 1, day).getDay()];

        return closedDays.includes(weekday) ? weekday : null;
    }

    async function loadSlots() {
        const displayHomeId = displayHomeInput.value;
        const date = dateInput.value;
        const closedDay = getClosedDay(date);

        // The browser's date picker can't disable weekdays, so a closed day is cleared instead
        if (closedDay) {
            request?.abort();
            dateInput.value = '';
            showTray(`This display home is closed on ${closedDay}s. Please choose another date.`, 'closed');
            return;
        }

        if (!displayHomeId || !date) {
            showTray('Choose a display home and date to see available times.', 'idle');
            return;
        }

        request?.abort();
        request = new AbortController();
        showTray('Finding times…', 'loading');

        try {
            const url = new URL(booking.dataset.slotsUrl, window.location.origin);
            url.searchParams.set('displayHomeId', displayHomeId);
            url.searchParams.set('date', date);

            const response = await fetch(url, {
                headers: { 'Accept': 'application/json' },
                signal: request.signal,
            });
            const data = await response.json();

            if (data.error) {
                showTray(data.error, 'error');
            } else if (!data.slots?.length) {
                showTray('There are no times available on this date. Please choose another date.', 'empty');
            } else {
                showTray('', 'ready', data.slots);
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                showTray('Sorry, we couldn’t load the available times. Please try again.', 'error');
            }
        }
    }

    async function loadHours() {
        const displayHomeId = displayHomeInput.value;

        hoursRequest?.abort();
        hoursList.replaceChildren();
        hours.hidden = true;
        closedDays = [];

        if (!displayHomeId) {
            return;
        }

        hoursRequest = new AbortController();

        try {
            const url = new URL(booking.dataset.hoursUrl, window.location.origin);
            url.searchParams.set('displayHomeId', displayHomeId);

            const response = await fetch(url, {
                headers: { 'Accept': 'application/json' },
                signal: hoursRequest.signal,
            });
            const data = await response.json();

            data.hours?.forEach(({ day, hours: dayHours }) => {
                const term = document.createElement('dt');
                const detail = document.createElement('dd');

                term.textContent = `${day}:`;
                detail.textContent = dayHours;
                hoursList.append(term, detail);
            });

            hours.hidden = !hoursList.children.length;
            closedDays = data.hours?.filter(({ isClosed }) => isClosed).map(({ day }) => day) ?? [];

            if (data.minDate && data.maxDate) {
                dateInput.min = data.minDate;
                dateInput.max = data.maxDate;
            }

            // A date picked before the hours arrived may fall on a closed day
            if (getClosedDay(dateInput.value)) {
                loadSlots();
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.warn('[Bookings] Unable to load opening hours.', error);
            }
        }
    }

    slotsList.addEventListener('change', event => {
        appointmentStartField.value = event.target.value;
    });

    displayHomeInput.addEventListener('change', () => {
        syncDisplayHome();
        loadHours();
        loadSlots();
    });

    dateInput.addEventListener('change', loadSlots);

    // Browsers can restore form values on back/forward without firing change
    window.addEventListener('pageshow', event => {
        if (event.persisted) {
            loadSlots();
        }
    });

    form.addEventListener('freeform-on-submit', event => {
        if (!displayHomeIdField.value || !appointmentStartField.value) {
            event.preventDefault();
            shiftTray(() => setMessage('Please choose a display home, date and time.', 'invalid'));
            slotsMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    });

    // Freeform resets the hidden fields after a successful submission
    form.addEventListener('freeform-ajax-success', () => {
        syncDisplayHome();
        loadSlots();
    });

    // The chosen time may have been taken, so refresh the list
    form.addEventListener('freeform-ajax-error', loadSlots);

    // ---- Success presentation (B4). Presentation only: the booking itself is submitted, validated and reset by
    // Freeform and the code above, exactly as before. The panel keeps the confirmation up, reads the booking back
    // from the inputs, runs a ~20s hairline, then resets for the next visitor. "Book another visit" resets at once.
    const successBlock = booking.querySelector('[data-booking-success]');
    const successHeading = booking.querySelector('[data-booking-success-heading]');
    const successSummary = booking.querySelector('[data-booking-success-summary]');
    const arrival = booking.querySelector('[data-booking-arrival]');
    const countdown = booking.querySelector('[data-booking-countdown]');
    const againButton = booking.querySelector('[data-booking-again]');
    const seconds = booking.querySelector('[data-booking-seconds]');
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const RESET_AFTER = 20000;
    let summaryText = '';
    let leaveTimer = null;
    let resetTimer = null;
    let tickTimer = null;

    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const replay = (el, className) => {
        el.classList.remove(className);
        void el.offsetWidth;
        el.classList.add(className);
    };

    // "Thursday 6 November, 10:00am · Into Kennedy Bay | One", read from the existing inputs
    function readBooking() {
        const [year, month, day] = dateInput.value.split('-').map(Number);
        const slot = slotsList.querySelector('input:checked');
        const slotLabel = slot ? slot.parentElement.querySelector('span').textContent.trim().replace(/\s*(am|pm)$/i, (m, ap) => ap.toLowerCase()) : '';
        const home = displayHomeInput.options[displayHomeInput.selectedIndex]?.text ?? '';
        const when = year ? `${weekdays[new Date(year, month - 1, day).getDay()]} ${day} ${months[month - 1]}` : '';

        return [[when, slotLabel].filter(Boolean).join(', '), home].filter(Boolean).join(' · ');
    }

    function enterSuccess() {
        booking.dataset.bookingView = 'success';
        successBlock.hidden = false;
        successSummary.textContent = summaryText;
        successSummary.hidden = !summaryText;
        replay(arrival, 'is-arriving');
        replay(countdown, 'is-running');
        successHeading.focus();
        resetTimer = setTimeout(resetPanel, RESET_AFTER);

        // The "Returning to the form in N seconds" line counts down with the hairline and the timer
        clearInterval(tickTimer);
        let remaining = RESET_AFTER / 1000;
        seconds.textContent = String(remaining);
        tickTimer = setInterval(() => {
            remaining -= 1;
            seconds.textContent = String(Math.max(remaining, 0));
        }, 1000);
    }

    function resetPanel() {
        clearTimeout(leaveTimer);
        clearTimeout(resetTimer);
        clearInterval(tickTimer);
        arrival.classList.remove('is-arriving');
        countdown.classList.remove('is-running');
        successBlock.hidden = true;
        booking.dataset.bookingView = 'entering';
        requestAnimationFrame(() => requestAnimationFrame(() => {
            booking.dataset.bookingView = 'form';
        }));

        // A clean picker for the next visitor (Freeform has already reset its own fields)
        dateInput.value = '';
        appointmentStartField.value = '';
        syncDisplayHome();
        loadSlots();
    }

    // Read before Freeform resets the fields on success
    form.addEventListener('freeform-on-submit', () => {
        summaryText = readBooking();
    });

    form.addEventListener('freeform-ajax-success', () => {
        clearTimeout(leaveTimer);
        clearTimeout(resetTimer);
        booking.dataset.bookingView = 'leaving';
        leaveTimer = setTimeout(enterSuccess, reducedMotion() ? 0 : 400);
    });

    againButton.addEventListener('click', resetPanel);

    // A time picked after "Please choose..." clears that prompt (the chips stay as they are)
    slotsList.addEventListener('change', () => {
        if (booking.dataset.bookingState === 'invalid') {
            shiftTray(() => setMessage('', 'ready'));
        }
    });


    // Restore the picker after a non-AJAX failed submission
    if (displayHomeIdField.value && !displayHomeInput.disabled) {
        displayHomeInput.value = displayHomeIdField.value;
    }
    if (/^\d{4}-\d{2}-\d{2}T/.test(appointmentStartField.value)) {
        dateInput.value = appointmentStartField.value.slice(0, 10);
    }

    syncDisplayHome();
    loadHours();
    loadSlots();
});
